import ContactFormContainer from './contact_form_container';

const ContactForm = ContactFormContainer;
export default ContactForm;



// WEBPACK FOOTER //
// ./src/hub_spot_form/components/contact_form/index.js